<template>
  <div>
    <div class="card d-inline-flex p-2">
      <h6 class="d-flex align-items-center mb-0">
        Сводка
        <b-button
            variant="link"
            @click="showTotalDetail"
        >
          (детали)
        </b-button>
      </h6>
      <div>
        <b>Всего пользоватeлей:</b> {{ totalUser }}
      </div>

      <div>
        <b>Дата последнего запуска:</b> {{ latestStartDay }}
      </div>
      <app-total-detail-modal
          ref="TotalDetailModal"
          :total-detail="totalDetail"
      />
    </div>
  </div>
</template>

<script>
import {ApiService} from "@/api";
import AppTotalDetailModal from "@/components/AppTotalDetailModal.vue";
import {eventBus} from "@/eventBus";

export default {
  name: 'AppTotal',
  components: {AppTotalDetailModal},
  data() {
    return {
      totalUser: 10,
      latestStartDay: '10.12.2023 12:12',
      totalDetail: {}
    }
  },
  created() {
    this.getTotal()
  },
  mounted() {
    eventBus.$on("deleteUser", this.getTotal);
  },
  beforeUnmount() {
    eventBus.$off("deleteUser", this.getTotal);
  },
  methods: {
    getTotal() {
      ApiService.getTotal()
          .then((res) => {
            this.totalUser = res.total
            this.latestStartDay = res.lastActivityDate
          })
    },
    showTotalDetail() {
      return ApiService.getTotalDetail()
          .then((res) => {
            this.totalDetail = res
            this.$refs.TotalDetailModal.open()
          })
          .catch(err => console.error(err))
    },
  }
}
</script>
